// extracted by mini-css-extract-plugin
module.exports = {"modal":"CheckingSpecialSocialPaymentModal_modal__3osCI","wrapper":"CheckingSpecialSocialPaymentModal_wrapper__1QLmO","title":"CheckingSpecialSocialPaymentModal_title__2jFnX"};